import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { sendTrackingInfo, ModalInformation } from '@panel/commons';

function OnHoldToOnCreditsNoEcomNo(props) {
  const { onClickAction, isInmobiliaria } = props;
  const { t } = useTranslation();

  useEffect(() => {
    const txt = `'Republicar Aviso en Espera_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}-Intencion`;
    sendTrackingInfo('Mis avisos', txt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickAction = e => {
    const txt = `Republicar Aviso en Espera sin credito_Cancelar_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickAction(e);
  };

  return (
    <ModalInformation
      onClickAction={e => handleClickAction(e)}
      onClickOutside={e => handleClickAction(e)}
      title={t('panel.modal.OnHoldToOn.title')}
      message={`${t('panel.modal.OnHoldToOn.subtitle')}`}
      linkTel={t('panel.sales.phoneNumber')}
      linkTelRef={t('panel.sales.phoneNumberRef')}
      linkTel2={t('panel.sales.phoneNumber.2')}
      linkTelRef2={t('panel.sales.phoneNumberRef.2')}
      linkTelText={t('panel.sales.city.1')}
      linkTelText2={t('panel.sales.city.2')}
      ctaOk={t('panel.modal.cta.ok')}
    />
  );
}

export { OnHoldToOnCreditsNoEcomNo };
